import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// ---------------------------------------------------------------
// Zeffy links — central configuration.
// Three live Zeffy forms cover all public sponsorship/volunteer/interest
// intents. ZEFFY_DONATE currently routes to /contact while a Zeffy
// donation form is finalized. The <ZeffyLink/> helper auto-detects
// internal "/" paths vs. external URLs.
// ---------------------------------------------------------------
// Unified 2027 conference campaign — replaces all individual Zeffy forms below (registration, VIP sponsorship, program support, gala tables, program book ad, vendor/exhibitor).
export const ZEFFY_UNIFIED          = "https://www.zeffy.com/en-US/ticketing/2027-north-central-region-spring-conference-and-phoenix-60th-anniversary-gala";

// Retained for evergreen (non-conference) & non-consolidated flows only:
export const ZEFFY_DONATE           = "/contact?type=donation";
export const ZEFFY_VOLUNTEER        = "https://www.zeffy.com/en-US/ticketing/phoenix-2027-volunteer-interest-form";
export const ZEFFY_INTEREST_LIST    = "https://www.zeffy.com/en-US/ticketing/phoenix-60th-anniversary-celebration-interest-list";

// Legacy aliases — kept as pointers to the unified campaign in case any external link references them.
export const ZEFFY_REGISTRATION     = ZEFFY_UNIFIED;
export const ZEFFY_SPONSOR          = ZEFFY_UNIFIED;
export const ZEFFY_SPONSOR_NCR      = ZEFFY_UNIFIED;
export const ZEFFY_SPONSOR_COMBINED = ZEFFY_UNIFIED;
export const ZEFFY_AD_JOURNAL       = ZEFFY_UNIFIED;
export const ZEFFY_TABLES           = ZEFFY_UNIFIED;
export const ZEFFY_PROGRAM_SUPPORT  = ZEFFY_UNIFIED;
export const ZEFFY_VENDOR           = ZEFFY_UNIFIED;
